<main id="main-wrapper">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="content-in ct-lg">
                    <h1 class="central-title">{{ title }}</h1>
                    <div class="normal-txt-in">
                        <h2 class="second-title">Bio</h2>
                        <p>
                            Bonjour, je suis développeur web front-end et infographiste, originaire des Comores, du village de Djoiezi, sur l'île de Mohéli.  Je vis à Moroni depuis maintenant plusieurs années.
                        </p>
                        <p>
                            C'est en 2010, à Marrakech, au Maroc, où j'ai commencé à écrire ma toute première page web. J'ai débuté ma formation sur le siteduzero (actuellement <a target="_blank" href="https://openclassrooms.com">OpenClassrooms</a> ).
                        </p>
                        <p>
                            Après être rentré aux Comores en 2014, j'ai participé plusieurs fois au concours de développement de site web régional <a target="_blank" href="https://webcup.fr">Webcup</a> où j'ai terminé 5 fois finaliste.
                        </p>
                        <p>
                            J'ai aussi travaillé pour des entreprises comme <strong>Hashiri</strong> et actuellement avec <a target="_blank" href="https://kinuink.com">Kinu Ink</a>.
                        </p>

                        <h2 class="second-title">Technologies que j'aime</h2>
                        <p>
                            Ayant commencé à écrire mes premières lignes de code en VB6 en 2008, j'ai évolué quelque temps après sur <strong>VB.NET</strong> que j'utilise assez rarement de nos jours.
                            Plus tard, j'ai appris le langage <strong>C</strong> que j'ai beaucoup aimé avant de me tourner vers le web.
                        </p>

                        <p>
                            Étant développeur front end, j'utilise donc fréquemment du <strong>HTML</strong>, <strong>CSS</strong> et <strong>JavaScript</strong>.
                        </p>
                        <p>
                            Je touche un peu au <strong>PHP</strong> que je trouve très évolué de nos jours. Je prefère par contre ne pas trop m'éloigner du JavaScript donc j'essaye d'avancer aussi avec du <strong>NodeJS</strong> (JavaScript côté serveur).
                        </p>
                        <p>
                            Côté base de données, j'aime beaucoup <strong>MySQL</strong> qui est relativement facile à appréhender. Je trouve bien d'avoir des connaissances en quelques systèmes de base de données de type <strong>NoSQL</strong> comme MongoDB.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>